import { render } from "./ImageUpscale.vue?vue&type=template&id=44d2aaac&scoped=true"
import script from "./ImageUpscale.vue?vue&type=script&lang=js"
export * from "./ImageUpscale.vue?vue&type=script&lang=js"

import "./ImageUpscale.vue?vue&type=style&index=0&id=44d2aaac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d2aaac"]])

export default __exports__